import { Routes } from '@angular/router';

export const authRoutes: Routes = [
  {
    path: 'register',
    loadComponent: () =>
      import('../components/registration/registration.component').then(
        (m) => m.RegistrationComponent,
      ),
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import(
        '../components/registration/accept-invitation/accept-invitation.component'
      ).then((m) => m.AcceptInvitationComponent),
  },
  {
    path: '**',
    redirectTo: 'register',
  },
];
